import {Component, OnInit} from '@angular/core';
import {AuthService} from '../../../auth/services/auth.service';

@Component({
  selector: 'app-myaccount',
  templateUrl: './my-account.component.html',
  styleUrls: ['./my-account.component.scss']
})
export class MyAccountComponent implements OnInit {
  public users: { id: string; name: string }[] = [];
  public companyId: string;

  constructor(private authService: AuthService) { }

  ngOnInit() {
    const token = this.authService.getDecodedJwtToken();

    this.users = [ { id: token.sub, name: token.name } ];
    this.companyId = token.CompanyId;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/admin/components/myaccount/my-account.component.ts